import Vue from 'vue';
import Router from 'vue-router';
import { getAuthCookie } from './utils/cookie';
import store from './store';
import { getIngroupPaths } from './services/navigationRBAC';
import { routes } from './routes';
import { hasPermissionToRoute } from './utils/permissions';

Vue.use(Router);

const SIGNIN_PATH = '/signin';
const DEFAULT_PATH = '/tickets';

export const router = new Router({
    routes
});

function userCanAccessRoute(route) {
    if(requiresAuthentication(route)) {
        let userIngroup = store.getters.user?.ingroup;
        if(!userIngroup) {
            return false;
        }
        if(requiresRBAC(route)) {
            let authorizedPaths = getIngroupPaths(userIngroup);
            let authorized = authorizedPaths.includes(route.path);
            if(authorized) {
                return hasPermissionToRoute(route);
            }
        }
    }
    return true;
}

function requiresRBAC(route) {
    return !route.meta.rbacNotRequired;
}
function requiresAuthentication(route) {
    return !route.meta.authenticationNotRequired;
}
function beforeRoute(to, from, next) {
    if (store.getters.forceOffline) {
        beforeRouteOffline(to, from, next);
    } else {
        beforeRouteOnline(to, from, next);
    }
}
function isOfflineRoute(route) {
    return route.path === '/offline/tickets' || route.path === '/offline/tickets/details';
}
function isKnownRoute(routeToFind) {
    for(let route of routes) {
        if(route.path === routeToFind) {
            return true;
        }
    }
    return false;
}
function beforeRouteOnline(to, from, next) {
    if(!isKnownRoute(to.path)) {
        if(!isKnownRoute(from.path)) {
            next({path: DEFAULT_PATH});
        }
        next(from);
    }
    const newtinCookie = getAuthCookie();
    store.commit('SET_IS_LOGGED_IN', !!newtinCookie);
    if (newtinCookie && store.getters.user?.ingroup) {
        if (to.path === '/' 
        || to.path === SIGNIN_PATH
        || !userCanAccessRoute(to)
        ) {
            if(from.path !== to.path) {
                next(from);
            } else {
                next({path: DEFAULT_PATH});
            }
            return;
        }
    } else if (requiresAuthentication(to)) {
        if(to.path !== '/' && to.path !== '/tickets') {
            next({ path: SIGNIN_PATH+`?redirectTo=${to.path}` });    
        } else {
            next({ path: SIGNIN_PATH });
        }
    }
    if (isOfflineRoute(to)) {
        next(from);
    } else {
        next();
    }
}
function beforeRouteOffline(to, from, next) {
    if (!isOfflineRoute(to)) {
        next({ path: '/offline/tickets' });
    } else {
        next();
    }
}
router.beforeEach((to, from, next) => beforeRoute(to, from, next));
